import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  rememberMe: {
    id: 'loginForm.rememberMe',
    defaultMessage: 'Muista minut',
  },
  loginFailed: {
    id: 'loginForm.loginFailed',
    defaultMessage: '! Kirjautuminen epäonnistui. Tarkista tunnus ja salasana.',
  },
  forgotPassword: {
    id: 'loginForm.forgotPassword',
    defaultMessage: 'Unohditko salasanasi?',
  },
  driverWorklistHeading: {
    id: 'loginForm.driverWorklistHeading',
    defaultMessage: 'Kuljettajan työlista ja kuormakirja',
  },
  customerServiceHeading: {
    id: 'loginForm.customerServiceHeading',
    defaultMessage: 'Asiakaspalvelu',
  },
})
